<template>
  <div class="container p-5 table-margin">
    <div class="d-flex flex-row justify-content-between flex-wrap pb-1">
      <h2 class="text-bg">Editar semilla</h2>
      <n-button type="info" size="medium" class="general-action-font-size" @click="$router.back()">
        <i class="icon-arrow-left p-1"></i>
        REGRESAR
      </n-button>
    </div>
    <n-form size="large" label-placement="top" :rules="rules" ref="formRef" :model="model">
      <div class="mt-5 mb-3">
        <n-form-item label="Nombre" path="name">
          <n-input type="text" id="inputName" v-model:value="model.name" placeholder="" />
        </n-form-item>
      </div>

      <div class="mb-3">
        <label class="general-label">Tipo de semilla</label>
        <n-tooltip trigger="hover">
          <template #trigger>
            <span class="info-sign-container">
              <i class="icon-info-sign info-sign" />
            </span>
          </template>
          Texto meramente descriptivo
        </n-tooltip>
        <n-input type="text" id="inputType" v-model:value="type" placeholder="Ingrese el tipo de semilla" />
      </div>

      <div class="mb-1">
        <n-form-item label="Estación" path="season">
          <n-checkbox-group v-model:value="model.season">
            <n-space item-style="display: flex;">
              <n-checkbox value="summer" label="Verano" />
              <n-checkbox value="winter" label="Invierno" />
            </n-space>
          </n-checkbox-group>
        </n-form-item>
      </div>

      <div>
        <n-form-item label="Precio por cantidad de bolsa" path="price">
          <div class="table-responsive w-100 bags-range-table">
            <table class="table table-hover">
              <thead class="table-head-dark">
                <tr>
                  <th scope="col" class="text-sm">Desde X cantidad</th>
                  <th scope="col" class="text-sm">Hasta X cantidad</th>
                  <th scope="col" class="text-sm">Precio por bolsa</th>
                  <th scope="col" class="text-align text-sm"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(bagRange, index) in bagsRange" :key="index">
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number
                      v-model:value="bagRange.from"
                      clearable
                      placeholder="Desde X cantidad"
                      :show-button="bagsRange.length - 1 == index ? true : false"
                      v-on:blur="handleEditFromAmount($event, index)"
                    />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number
                      v-model:value="bagRange.to"
                      :placeholder="index === bagsRange.length - 1 ? 'MAX' : 'Hasta X cantidad'"
                      :show-button="bagsRange.length - 1 == index ? true : false"
                      v-on:blur="handleEditUpToAmount($event, index)"
                      :disabled="index === bagsRange.length - 1 && true"
                    />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number
                      v-model:value="bagRange.price"
                      clearable
                      placeholder="Precio por cantidad"
                      :min="0"
                      :show-button="bagsRange.length - 1 == index ? true : false"
                    />
                  </td>
                  <td scope="row" class="align-middle">
                    <n-tooltip trigger="hover" v-if="index >= 0">
                      <template #trigger>
                        <span @click="deleteBagsRow(index)" class="info-sign-container">
                          <i class="icon-trash" />
                        </span>
                      </template>
                      Eliminar
                    </n-tooltip>
                    <n-tooltip trigger="hover" v-if="index == bagsRange.length - 1">
                      <template #trigger>
                        <span @click="addField(index)" class="general-seed-icon">
                          <i class="icon-plus" />
                        </span>
                      </template>
                      Nuevo rango
                    </n-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </n-form-item>
      </div>

      <div class="mb-3">
        <n-form-item label="Proveedor" path="provider">
          <n-select v-model:value="model.provider" :options="providerOptions" placeholder="Seleccione un proveedor" />
        </n-form-item>
      </div>

      <div class="mb-3">
        <n-form-item label="Producto" path="product">
          <n-select v-model:value="model.product" :options="productOptions" placeholder="Seleccione un producto" />
        </n-form-item>
      </div>

      <div class="mb-4 form-group">
        <n-h3 style="font-weight: 700">
          Suministros
          <n-tooltip trigger="hover">
            <template #trigger>
              <span class="general-seed-icon">
                <i class="icon-info-sign info-sign" />
              </span>
            </template>
            Desde aqui podras seleccionar tantos suministros como quieras (o ninguno)
          </n-tooltip>
        </n-h3>
        <div>
          <div class="mb-3">
            <n-form-item label="Aditivos" path="additive">
              <n-select v-model:value="additive" :options="additiveOptions" placeholder="Seleccione aditivo" />
            </n-form-item>
          </div>

          <!-- ADDITIVES TABLE -->

          <div class="table-responsive supply-table-seeds" v-show="this.seedAdditives?.length > 0">
            <table class="table table-hover">
              <thead class="table-head-dark">
                <tr>
                  <th scope="col" class="text-sm">Suministro</th>
                  <th scope="col" class="text-sm">Formato</th>
                  <th scope="col" class="text-sm">Dosis recomendada <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis minima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis maxima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Default</th>
                  <th scope="col" class="text-align text-sm"></th>
                </tr>
              </thead>
              <tbody>
                <tr scope="row" v-if="this.seedAdditives?.length === 0" style="width: 50vw; height: 2rem">
                  <td colspan="4" class="text-center">
                    <n-p>No hay aditivos agregados aún</n-p>
                  </td>
                </tr>
                <tr v-else-if="this.seedAdditives?.length > 0" v-for="(additive, index) in seedAdditives" :key="index">
                  <td scope="row" class="align-middle text-sm">
                    {{ additive.name }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    {{ additive.format?.toUpperCase() }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="additive.dose.recommended" clearable placeholder="Dosis recomendada" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="additive.dose.min" clearable placeholder="Dosis minima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="additive.dose.max" clearable placeholder="Dosis maxima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-checkbox v-model:checked="additive.isDefault" />
                  </td>
                  <td scope="row" class="align-middle">
                    <n-tooltip trigger="hover">
                      <template #trigger>
                        <span @click="deleteSupplyFromTable(this.seedAdditives, this.additiveOptions, index)" class="general-seed-icon">
                          <i class="icon-trash" />
                        </span>
                      </template>
                      Eliminar
                    </n-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <n-form-item label="Fertilizante" path="fertilizer">
              <n-select v-model:value="fertilizer" :options="fertilizerOptions" placeholder="Seleccione un fertilizante" />
            </n-form-item>
          </div>

          <!-- FERTILIZER TABLE -->

          <div class="table-responsive bags-range-table" v-show="this.seedFertilizer?.length > 0">
            <table class="table table-hover">
              <thead class="table-head-dark">
                <tr>
                  <th scope="col" class="text-sm">Suministro</th>
                  <th scope="col" class="text-sm">Formato</th>
                  <th scope="col" class="text-sm">Dosis recomendada <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis minima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis maxima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Default</th>
                  <th scope="col" class="text-align text-sm"></th>
                </tr>
              </thead>
              <tbody>
                <tr scope="row" v-if="this.seedFertilizer?.length === 0" style="width: 50vw; height: 2rem">
                  <td colspan="4" class="text-center">
                    <n-p>No hay fertilizantes agregados aún</n-p>
                  </td>
                </tr>
                <tr v-else-if="this.seedFertilizer?.length > 0" v-for="(fertilizer, index) in seedFertilizer" :key="index">
                  <td scope="row" class="align-middle text-sm">
                    {{ fertilizer.name }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    {{ fertilizer.format?.toUpperCase() }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizer.dose.recommended" clearable placeholder="Dosis recomendada" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizer.dose.min" clearable placeholder="Dosis minima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizer.dose.max" clearable placeholder="Dosis maxima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-checkbox v-model:checked="fertilizer.isDefault" />
                  </td>
                  <td scope="row" class="align-middle">
                    <n-tooltip trigger="hover">
                      <template #trigger>
                        <span @click="deleteSupplyFromTable(this.seedFertilizer, this.fertilizerOptions, index)" class="general-seed-icon">
                          <i class="icon-trash" />
                        </span>
                      </template>
                      Eliminar
                    </n-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <n-form-item label="Fertilizante + Fitosanitarios" path="fertilizerAndPhytosanitary">
              <n-select
                v-model:value="fertilizerAndPhytosanitary"
                :options="fertilizerAndPhytosanitaryOptions"
                placeholder="Seleccione un fertilizante + fitosanitario"
              />
            </n-form-item>
          </div>

          <!-- FERTILIZER+PHYTOSANITARY TABLE -->

          <div class="table-responsive supply-table-seeds" v-show="this.seedFertilizerAndPhytosanitary?.length > 0">
            <table class="table table-hover">
              <thead class="table-head-dark">
                <tr>
                  <th scope="col" class="text-sm">Suministro</th>
                  <th scope="col" class="text-sm">Formato</th>
                  <th scope="col" class="text-sm">Dosis recomendada <span style="color: #d03050">*</span></th>
                  <th scope="col" class="text-sm">Dosis minima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis maxima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Default</th>
                  <th scope="col" class="text-align text-sm"></th>
                </tr>
              </thead>
              <tbody>
                <tr scope="row" v-if="this.seedFertilizerAndPhytosanitary?.length === 0" style="width: 50vw; height: 2rem">
                  <td colspan="4" class="text-center">
                    <n-p>No hay fertilizantes + fitosanitarios agregados aún</n-p>
                  </td>
                </tr>
                <tr
                  v-else-if="this.seedFertilizerAndPhytosanitary?.length > 0"
                  v-for="(fertilizerAndPhytosanitary, index) in seedFertilizerAndPhytosanitary"
                  :key="index"
                >
                  <td scope="row" class="align-middle text-sm">
                    {{ fertilizerAndPhytosanitary.name }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    {{ fertilizerAndPhytosanitary.format?.toUpperCase() }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizerAndPhytosanitary.dose.recommended" clearable placeholder="Dosis recomendada" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizerAndPhytosanitary.dose.min" clearable placeholder="Dosis minima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="fertilizerAndPhytosanitary.dose.max" clearable placeholder="Dosis maxima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-checkbox v-model:checked="fertilizerAndPhytosanitary.isDefault" />
                  </td>
                  <td scope="row" class="align-middle">
                    <n-tooltip trigger="hover">
                      <template #trigger>
                        <span
                          @click="deleteSupplyFromTable(this.seedFertilizerAndPhytosanitary, this.fertilizerAndPhytosanitaryOptions, index)"
                          class="general-seed-icon"
                        >
                          <i class="icon-trash" />
                        </span>
                      </template>
                      Eliminar
                    </n-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <n-form-item label="Fitosanitarios" path="phytosanitary">
              <n-select v-model:value="phytosanitary" :options="phytosanitaryOptions" placeholder="Seleccione un fitosanitario" />
            </n-form-item>
          </div>

          <!-- PHYTOSANITARY TABLE -->

          <div class="table-responsive supply-table-seeds" v-show="this.seedPhytosanitary?.length > 0">
            <table class="table table-hover">
              <thead class="table-head-dark">
                <tr>
                  <th scope="col" class="text-sm">Suministro</th>
                  <th scope="col" class="text-sm">Formato</th>
                  <th scope="col" class="text-sm">Dosis recomendada <span style="color: #d03050">*</span></th>
                  <th scope="col" class="text-sm">Dosis minima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Dosis maxima <span class="required-sign">*</span></th>
                  <th scope="col" class="text-sm">Default</th>
                  <th scope="col" class="text-align text-sm"></th>
                </tr>
              </thead>
              <tbody>
                <tr scope="row" v-if="this.seedPhytosanitary?.length === 0" style="width: 50vw; height: 2rem">
                  <td colspan="4" class="text-center">
                    <n-p>No hay fitosanitarios agregados aún</n-p>
                  </td>
                </tr>
                <tr v-else-if="this.seedPhytosanitary?.length > 0" v-for="(phytosanitary, index) in seedPhytosanitary" :key="index">
                  <td scope="row" class="align-middle text-sm">
                    {{ phytosanitary.name }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    {{ phytosanitary.format?.toUpperCase() }}
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="phytosanitary.dose.recommended" clearable placeholder="Dosis recomendada" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="phytosanitary.dose.min" clearable placeholder="Dosis minima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-input-number v-model:value="phytosanitary.dose.max" clearable placeholder="Dosis maxima" min="0" />
                  </td>
                  <td scope="row" class="align-middle text-sm">
                    <n-checkbox v-model:checked="phytosanitary.isDefault" />
                  </td>
                  <td scope="row" class="align-middle">
                    <n-tooltip trigger="hover">
                      <template #trigger>
                        <span @click="deleteSupplyFromTable(this.seedPhytosanitary, this.phytosanitaryOptions, index)" class="general-seed-icon">
                          <i class="icon-trash" />
                        </span>
                      </template>
                      Eliminar
                    </n-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="mb-4 form-group d-flex">
        <div class="mb-3 w-50">
          <n-h3 class="font-weight-bold"> Gasoil </n-h3>
          <div class="mb-3 d-flex flex-column align-items-center seed-gap">
            <n-form-item label="Litros recomendados" path="recommendedGasoil">
              <n-input-number
                class="gasoil-and-performance-width"
                v-model:value="model.recommendedGasoil"
                clearable
                placeholder="Litros recomendados"
                min="0"
                :status="this.gasoilStatus"
              />
            </n-form-item>

            <n-form-item label="Litros minimos" path="gasoil.min">
              <n-input-number class="gasoil-and-performance-width" v-model:value="gasoil.min" clearable placeholder="Litros mínimos" min="0" />
            </n-form-item>

            <n-form-item label="Litros maximos" path="gasoil.min">
              <n-input-number class="gasoil-and-performance-width" v-model:value="gasoil.max" clearable placeholder="Litros máximos" min="0" />
            </n-form-item>
          </div>
        </div>
        <div class="mb-3 w-50 h-100">
          <n-h3 class="font-weight-bold">Performance (Kilos por hectarea)</n-h3>
          <div class="mb-3 d-flex flex-column align-items-center seed-gap">
            <n-form-item label="Estimado" path="performancePerHectare.estimate">
              <n-input-number class="gasoil-and-performance-width" v-model:value="performancePerHectare.estimate" clearable placeholder="Estimado" min="0" />
            </n-form-item>
            <n-form-item label="Minimo" path="performancePerHectare.min">
              <n-input-number class="gasoil-and-performance-width" v-model:value="performancePerHectare.min" clearable placeholder="Estimado" min="0" />
            </n-form-item>
            <n-form-item label="Máximo" path="performancePerHectare.max">
              <n-input-number class="gasoil-and-performance-width" v-model:value="performancePerHectare.max" clearable placeholder="Maximo" min="0" />
            </n-form-item>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <n-form-item label="Boost de productividad" path="productivityBoost">
          <n-space justify="space-around" class="input wrapper d-flex flex-row items-center w-100">
            <n-input-number v-model:value="productivityBoost.min" clearable placeholder="Minimo" min="0" max="99">
              <template #suffix> % </template>
            </n-input-number>
            <n-input-number v-model:value="productivityBoost.max" clearable placeholder="Maximo" min="0" max="100">
              <template #suffix> % </template>
            </n-input-number>
          </n-space>
        </n-form-item>
      </div>

      <n-form-item label="Cantidad por bolsa" class="w-100">
        <div class="w-100 p-3">
          <n-form-item label="Formato" path="bagFormat">
            <n-radio-group v-model:value="model.bagFormat" name="bagFormat">
              <n-space>
                <n-radio @change="handleRadioValueChange" :checked="model.bagFormat === 'kg'" value="kg"> Kg </n-radio>
                <n-radio @change="handleRadioValueChange" :checked="model.bagFormat === 'seeds'" value="seeds"> Semillas </n-radio>
              </n-space>
            </n-radio-group>
          </n-form-item>

          <div v-if="model.bagFormat && model.bagFormat == 'kg'">
            <label>Cantidad</label>
            <n-input-number v-model:value="amountPerBag.kg" clearable placeholder="45" min="0" class="w-100">
              <template #suffix> KG </template>
            </n-input-number>
          </div>
          <div v-if="model.bagFormat && model.bagFormat == 'seeds'">
            <label>Cantidad</label>
            <n-input-number v-model:value="amountPerBag.seeds" clearable placeholder="80000" min="0" class="w-100">
              <template #suffix> Semillas </template>
            </n-input-number>
          </div>
        </div>
      </n-form-item>

      <div class="mb-3">
        <n-form-item label="Cantidad de bolsas por hectarea" path="bagsPerHectare">
          <n-space justify="space-around" class="input wrapper d-flex flex-row items-center w-100">
            <n-form-item label="Cantidad recomendada" path="recommendedBagsPerHectare">
              <n-input-number
                class="gasoil-and-performance-width"
                v-model:value="model.recommendedBagsPerHectare"
                clearable
                placeholder="Cantidad recomendada"
                min="0"
              />
            </n-form-item>
            <n-form-item label="Cantidad minima">
              <n-input-number v-model:value="bagsPerHectare.min" clearable placeholder="Cantidad mínima" min="0" />
            </n-form-item>
            <n-form-item label="Cantidad maxima">
              <n-input-number v-model:value="bagsPerHectare.max" clearable placeholder="Cantidad máxima" min="0" />
            </n-form-item>
          </n-space>
        </n-form-item>
      </div>

      <div class="mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" @change="switchIsAvailable($event)" :checked="isAvailable" />
          <label class="form-check-label" for="flexSwitchCheckDisabled">{{ isAvailable ? "Semilla disponible" : "Semilla no disponible" }}</label>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <n-button :disabled="disableButton" type="info" class="text-center w-100" @click="editSeed" style="font-size: 20px">
          <i class="icon-plus" style="padding-right: 12px"></i>
          EDITAR SUMINISTRO
        </n-button>
      </div>
    </n-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage, useLoadingBar } from "naive-ui";
import authStore from "../../store/auth.js";
import productStore from "../../store/product";
import seedStore from "../../store/seed";
import supplyStore from "../../store/supply";
import providerStore from "../../store/provider.js";

export default {
  data() {
    return {
      message: useMessage(),
      loadingBar: useLoadingBar(),
      formRef: null,
      model: {
        name: null,
        provider: null,
        recommendedGasoil: null,
        season: null,
        bagFormat: null,
        recommendedBagsPerHectare: null,
        product: null,
      },
      rules: {
        name: {
          validator: this.validateName,
          required: true,
          trigger: "blur",
        },
        product: {
          required: true,
          message: "Por favor seleccione un producto",
          trigger: "blur",
        },
        provider: {
          required: true,
          message: "Por favor ingrese un proveedor",
          trigger: "blur",
        },
        recommendedGasoil: {
          required: true,
          message: "Por favor ingrese una cantidad de gasoil recomendada",
          trigger: "blur",
          validator(rule, value) {
            if (value < 0) {
              return false;
            } else return true;
          },
        },
        season: {
          required: true,
          message: "Por favor, seleccione al menos una estación",
          validator(rule, value) {
            if (!value) {
              return false;
            } else return true;
          },
          trigger: "blur",
        },
        bagFormat: {
          required: true,
          trigger: "blur",
          message: "Por favor ingrese un formato",
          validator(rule, value) {
            if (!value) {
              return false;
            } else return true;
          },
        },
        recommendedBagsPerHectare: {
          required: true,
          message: "Por favor ingrese una cantidad de bolsas por hectarea recomendada",
          trigger: "blur",
          validator(rule, value) {
            if (!value) {
              return false;
            } else return true;
          },
        },
      },
      type: null,
      season: {
        winter: null,
        summer: null,
      },
      provider: null,
      additive: null,
      fertilizer: null,
      fertilizerAndPhytosanitary: null,
      phytosanitary: null,
      gasoil: {
        recommended: null,
        min: null,
        max: null,
      },
      bagsRange: [],
      performancePerHectare: {
        recommended: null,
        min: null,
        max: null,
      },
      productivityBoost: {
        min: null,
        max: null,
      },
      bagsPerHectare: {
        recommended: null,
        min: null,
        max: null,
      },
      bagFormat: "",
      amountPerBag: {
        kg: 45,
        seeds: 80000,
      },
      fertilizerOptions: [],
      additiveOptions: [],
      fertilizerAndPhytosanitaryOptions: [],
      phytosanitaryOptions: [],
      providerOptions: [],
      productOptions: [],
      seedAdditives: [],
      seedFertilizer: [],
      seedFertilizerAndPhytosanitary: [],
      seedPhytosanitary: [],
      seasonStatus: {
        border: "1px solid rgb(224, 224, 230)",
      },
      isFormValid: true,
      seedNames: [],
      isAvailable: null,
    };
  },
  computed: {
    ...mapState(providerStore, ["providers"]),
    ...mapState(productStore, ["products"]),
    ...mapState(supplyStore, ["supplies"]),
    ...mapState(authStore, ["isLoggedIn"]),
  },
  async created() {
    const res = await this.getSeedById(this.$route.params.id);
    const seed = await res.result;

    // set data from db
    this.model.product = seed.product;
    this.gasoil = seed.gasoil;
    this.performancePerHectare = seed.performancePerHectare;
    this.productivityBoost = seed.productivityBoost;
    this.amountPerBag = seed.amountPerBag;
    this.bagFormat = seed.amountPerBag.kg == null ? "seeds" : "kg";
    this.amountPerBag.kg = seed.amountPerBag.kg == null ? 45 : seed.amountPerBag.kg;
    this.amountPerBag.seeds = seed.amountPerBag.seeds == null ? 80000 : seed.amountPerBag.seeds;
    this.bagsPerHectare = seed.bagsPerHectare;
    this.bagsRange = seed.pricePerBag;
    this.isAvailable = seed.isAvailable;

    let seasonData = [];
    if (seed.season.winter) {
      seasonData.push("winter");
    }
    if (seed.season.summer) {
      seasonData.push("summer");
    }

    this.model.name = seed.name;
    this.model.provider = seed.provider._id;
    this.model.recommendedGasoil = seed.gasoil.recommended;
    this.model.recommendedBagsPerHectare = seed.bagsPerHectare.recommended;
    this.model.season = seasonData;
    this.model.bagFormat = seed.format;

    // Prepare name validation

    let data = await this.getNames();
    this.seedNames = data.filter(seed => seed.name != this.model.name);

    // get providers options

    await this.getAllProviders();
    await this.getProvidersById(seed.provider._id);
    const filteredProviders = this.providers.filter(provider => {
      return provider.type.find(type => {
        if (type === "seed") {
          provider.label = provider.name;
          provider.value = provider._id;
          return true;
        }
      });
    });
    this.providerOptions = filteredProviders;
    await this.getAllProducts();
    const filteredProducts = [];
    this.products.forEach(product => {
      filteredProducts.push({
        label: (product.label = product.name),
        value: (product.value = product._id),
      });
    });
    this.productOptions = filteredProducts;

    // get supplies options
    await this.getAllSupplies();
    const additiveSupplies = this.supplies.filter(supply => supply.type === "additive");
    const fertilizerSupplies = this.supplies.filter(supply => supply.type === "fertilizer");
    const fertilizerAndPhytosanitarySupplies = this.supplies.filter(supply => supply.type === "fertilizerAndPhytosanitary");
    const phytosanitarySupplies = this.supplies.filter(supply => supply.type === "phytosanitary");
    const gasoilSupplies = this.supplies.filter(supply => supply.type === "gasoil");

    this.fertilizerOptions = this.assignOptions(fertilizerSupplies);
    this.fertilizerAndPhytosanitaryOptions = this.assignOptions(fertilizerAndPhytosanitarySupplies);
    this.phytosanitaryOptions = this.assignOptions(phytosanitarySupplies);
    this.additiveOptions = this.assignOptions(additiveSupplies);
    this.gasoilOptions = this.assignOptions(gasoilSupplies);

    // select supplies from db
    for (let i = 0; i < seed.supplies.length; i++) {
      if (seed.supplies[i].supply.type == "additive") {
        seed.supplies[i].name = seed.supplies[i].supply.name;
        seed.supplies[i].format = seed.supplies[i].supply.format;
        this.seedAdditives.push(seed.supplies[i]);

        for (let j = 0; j < this.additiveOptions.length; j++) {
          if (seed.supplies[i].supply._id === this.additiveOptions[j].value) {
            this.additiveOptions[j].disabled = true;
          }
        }
      }
      if (seed.supplies[i].supply.type == "fertilizer") {
        seed.supplies[i].name = seed.supplies[i].supply.name;
        seed.supplies[i].format = seed.supplies[i].supply.format;
        this.seedFertilizer.push(seed.supplies[i]);

        for (let j = 0; j < this.fertilizerOptions.length; j++) {
          if (seed.supplies[i].supply._id === this.fertilizerOptions[j].value) {
            this.fertilizerOptions[j].disabled = true;
          }
        }
      }
      if (seed.supplies[i].supply.type == "phytosanitary") {
        seed.supplies[i].name = seed.supplies[i].supply.name;
        seed.supplies[i].format = seed.supplies[i].supply.format;
        this.seedPhytosanitary.push(seed.supplies[i]);

        for (let j = 0; j < this.phytosanitaryOptions.length; j++) {
          if (seed.supplies[i].supply._id === this.phytosanitaryOptions[j].value) {
            this.phytosanitaryOptions[j].disabled = true;
          }
        }
      }

      if (seed.supplies[i].supply.type == "fertilizerAndPhytosanitary") {
        seed.supplies[i].name = seed.supplies[i].supply.name;
        seed.supplies[i].format = seed.supplies[i].supply.format;
        this.seedFertilizerAndPhytosanitary.push(seed.supplies[i]);

        for (let j = 0; j < this.fertilizerAndPhytosanitaryOptions.length; j++) {
          if (seed.supplies[i].supply._id === this.fertilizerAndPhytosanitaryOptions[j].value) {
            this.fertilizerAndPhytosanitaryOptions[j].disabled = true;
          }
        }
      }
    }
  },
  async mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
  },
  watch: {
    additive(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== null) {
        this.pushAdditive(newValue);
        this.additive = null;
      }
    },
    fertilizer(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== null) {
        this.pushFertilizer(newValue);
        this.fertilizer = null;
      }
    },
    fertilizerAndPhytosanitary(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== null) {
        this.pushFertilizerAndPhytosanitary(newValue);
        this.fertilizerAndPhytosanitary = null;
      }
    },
    phytosanitary(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== null) {
        this.pushPhytosanitary(newValue);
        this.phytosanitary = null;
      }
    },
  },
  methods: {
    ...mapActions(providerStore, ["getProvidersById", "getAllProviders"]),
    ...mapActions(productStore, ["getProductsById", "getAllProducts"]),
    ...mapActions(supplyStore, ["getAllSupplies"]),
    ...mapActions(seedStore, ["getSeedById", "updateSeed", "getNames"]),
    switchIsAvailable(e) {
      this.isAvailable = e.target.checked;
    },
    handleRadioValueChange(e) {
      this.model.bagFormat = e.target.value;
    },
    validateName(rule, value) {
      const nameAlreadyExists = (input, names) => {
        for (let seed of names) {
          if (seed.name?.toLowerCase() == input.toLowerCase()) {
            return true;
          } else return false;
        }
      };
      if (!value) {
        rule.message = "Por favor ingrese un nombre";
        return false;
      } else {
        if (nameAlreadyExists(value, this.seedNames)) {
          rule.message = "Ese nombre ya existe";
          return false;
        } else return true;
      }
    },
    handleEditFromAmount(e, index) {
      let newValue = Number(e.target._value);
      let prevRange = this.bagsRange[index - 1];
      let nextRange = this.bagsRange[index + 1];
      let thisRange = this.bagsRange[index];

      let newValueIsWithinThisRangeOrThePrevOne = newValue >= prevRange?.from;
      let newValueIsWithinThisRangeOrThePrevOneMiddle = newValue >= prevRange?.from && newValue < thisRange.to;
      let newValueEscapesNextRange = newValue > thisRange?.to;
      let newValueEscapesPrevRange = newValue < prevRange?.from;
      let userTriesToReplaceFirstObject = newValue >= this.bagsRange[0].from && newValue < this.bagsRange[0].to;
      let usersTriesToReplaceLastObject = newValue > this.bagsRange[this.bagsRange.length - 1]?.from;
      let editingFirstRow = index === 0;
      let editingLastRow = index === this.bagsRange.length - 1;

      if (editingFirstRow) {
        if (newValue !== 0) {
          thisRange.from = 0;
        }
      } else if (editingLastRow) {
        if (newValueIsWithinThisRangeOrThePrevOne) {
          if (newValue === prevRange.from) {
            this.bagsRange.splice(index - 1, 1);
          } else {
            prevRange.to = newValue - 1;
          }
        } else if (newValueEscapesPrevRange) {
          if (userTriesToReplaceFirstObject) {
            this.bagsRange = [{ from: 0, to: thisRange?.to, price: thisRange.price }];
          } else {
            let to = this.bagsRange[index].to;
            for (let i = index - 1; i >= 0; i--) {
              // Loop from the end because we're there
              if (newValue >= this.bagsRange[i].from && newValue < this.bagsRange[i].to) {
                this.bagsRange[i - 1].to = newValue - 1;
                this.bagsRange[i].from = newValue;
                this.bagsRange[i].to = to;
                this.bagsRange.pop();
                break;
              } else {
                this.bagsRange.splice(i, 1);
              }
            }
          }
        }
      } else {
        console.log("middle");
        // I'm modifying the middle
        if (newValueIsWithinThisRangeOrThePrevOneMiddle) {
          prevRange.to = newValue - 1;
          if (newValue === prevRange?.from) {
            this.bagsRange.splice(index - 1, 1);
          }
        } else if (newValueEscapesPrevRange) {
          if (userTriesToReplaceFirstObject) {
            let clone = [];
            clone.push({ from: 0, to: thisRange?.to, price: thisRange.price });
            for (let i = index + 1; i < this.bagsRange.length; i++) {
              clone.push(this.bagsRange[i]);
            }
            this.bagsRange = [...clone];
          } else {
            for (let i = index - 1; i >= 0; i--) {
              // Loop from the end because we're there
              if (newValue >= this.bagsRange[i].from && newValue < this.bagsRange[i].to) {
                this.bagsRange[i - 1].to = newValue - 1;
                // this.bagsRange[i].from = newValue;
                this.bagsRange.splice(i, 1);
                break;
              } else {
                this.bagsRange.splice(i, 1);
              }
            }
          }
        } else if (newValueEscapesNextRange) {
          if (usersTriesToReplaceLastObject) {
            let clone = [];
            let newLastObject = {
              from: newValue,
              to: this.bagsRange[this.bagsRange.length - 1].to,
              price: this.bagsRange[this.bagsRange.length - 1].price,
            };
            for (let i = 0; i < this.bagsRange.length; i++) {
              if (i < index) {
                clone.push(this.bagsRange[i]);
              }
            }
            this.bagsRange = [...clone, newLastObject];
            this.bagsRange[index - 1].to = newValue - 1;
            if (this.bagsRange[index].from > this.bagsRange[index].to) {
              this.bagsRange[index].to = this.bagsRange[index].from + 99;
            }
            this.bagsRange[this.bagsRange.length - 1].to = null;
          } else {
            if (newValue > nextRange.from && newValue < nextRange.to) {
              thisRange.to = nextRange.to;
              prevRange.to = thisRange.from - 1;
              this.bagsRange.splice(index + 1, 1);
            } else {
              for (let i = index + 1; i < this.bagsRange.length; i++) {
                if (newValue >= this.bagsRange[i].from && newValue < this.bagsRange[i].to) {
                  this.bagsRange.splice(index + 1, 1);
                  prevRange.to = newValue - 1;
                  thisRange.to = this.bagsRange[i].from - 1;
                  break;
                } else {
                  this.bagsRange.splice(i, 1);
                  i--;
                }
              }
            }
          }
        }
      }
    },
    handleEditUpToAmount(e, index) {
      let newValue = Number(e.target._value);
      let prevRange = this.bagsRange[index - 1];
      let nextRange = this.bagsRange[index + 1];
      let thisRange = this.bagsRange[index];

      let newValueIsWithinThisRangeOrTheNextOne =
        (newValue >= nextRange?.from && newValue < nextRange?.to) || (newValue > thisRange?.from && newValue <= nextRange?.from);
      let newValueEscapesNextRange = newValue > nextRange?.to;
      let newValueIsInPrevRange = newValue <= prevRange?.to && newValue > prevRange?.from;
      let newValueEscapesPrevRange = newValue < prevRange?.from;
      let usersTriesToReplaceLastObject = newValue >= this.bagsRange[this.bagsRange.length - 1].to;
      let usersTriesToReplaceLastObjectFrom = newValue >= this.bagsRange[this.bagsRange.length - 1].from;
      let userTriesToReplaceFirstObject = newValue > 0 && newValue <= this.bagsRange[0].to;
      let editingFirstRow = index === 0;
      let editingLastRow = index === this.bagsRange.length - 1;

      if (editingFirstRow) {
        // Modifying the first element
        if (newValue === 0) {
          thisRange.to = 1;
          nextRange.from = 2;
        } else if (newValue == nextRange.to) {
          this.bagsRange.splice(1, 1);
        } else {
          if (newValueIsWithinThisRangeOrTheNextOne) {
            nextRange.from = newValue + 1;
          } else if (newValueEscapesNextRange) {
            for (let i = 1; i < this.bagsRange.length; i++) {
              if (newValue >= this.bagsRange[i].from && newValue < this.bagsRange[i].to) {
                this.bagsRange[i].from = newValue + 1;
                break;
              } else {
                this.bagsRange.splice(i, 1);
                i--;
              }
            }
            this.bagsRange[this.bagsRange.length - 1].to = null;
          } else if (usersTriesToReplaceLastObjectFrom) {
            let price = this.bagsRange[0].price;
            this.bagsRange = [];
            this.bagsRange = [{ from: 0, to: null, price: price }];
          }
        }
      } else if (editingLastRow) {
        // console.log('never gonna happen');
        // if (!newValue){
        // } else if (newValue < thisRange.from){
        //     if (newValueIsInPrevRange){
        //         prevRange.to = newValue;
        //         this.bagsRange.pop();
        //     } else if (newValueEscapesPrevRange){
        //         let price = this.bagsRange[index].price
        //         for (let i = index; i >= 0; i--){
        //             if (newValue > this.bagsRange[i].from && newValue <= this.bagsRange[i].to){
        //                 this.bagsRange[i].to = newValue;
        //                 this.bagsRange[i].price = price;
        //                 break;
        //             } else {
        //                 this.bagsRange.pop();
        //             }
        //         }
        //     }
        // }
      } else {
        // I'm modifying the middle
        if (newValueIsWithinThisRangeOrTheNextOne) {
          nextRange.from = newValue + 1;
        } else if (newValueEscapesNextRange) {
          if (usersTriesToReplaceLastObjectFrom) {
            let clone = [];
            for (let i = 0; i < index; i++) {
              clone.push(this.bagsRange[i]);
            }
            let object = {
              from: this.bagsRange[index].from,
              to: newValue,
              price: this.bagsRange[index].price,
            };

            this.bagsRange = [...clone, object];
            this.bagsRange[this.bagsRange.length - 1].to = null;
          } else {
            for (let i = index + 1; i < this.bagsRange.length; i++) {
              if (newValue > this.bagsRange[i].from && newValue < this.bagsRange[i].to) {
                this.bagsRange[i].from = newValue + 1;
                break;
              } else if (newValue > this.bagsRange[i].from && newValue === this.bagsRange[i].to) {
                this.bagsRange.splice(i, 1);
                break;
              } else {
                this.bagsRange.splice(i, 1);
                i--;
              }
            }
          }
        } else if (newValueIsInPrevRange) {
          prevRange.to = newValue;
          nextRange.from = prevRange.to + 1;
          this.bagsRange.splice(index, 1);
        } else if (newValueEscapesPrevRange) {
          if (userTriesToReplaceFirstObject) {
            let clone = [];
            for (let i = index + 1; i < this.bagsRange.length; i++) {
              clone.push(this.bagsRange[i]);
            }
            let object = {
              from: 0,
              to: newValue,
              price: this.bagsRange[index].price,
            };
            this.bagsRange = [object, ...clone];
            this.bagsRange[1].from = newValue + 1;
          } else {
            for (let i = index; i > 0; i--) {
              if (newValue > this.bagsRange[i].from && newValue <= this.bagsRange[i].to) {
                this.bagsRange[i].to = newValue;
                this.bagsRange[i + 1].from = newValue + 1;
                break;
              } else {
                this.bagsRange.splice(i, 1);
              }
            }
          }
        }
      }
    },
    deleteBagsRow(index) {
      if (this.bagsRange.length > 1) {
        if (index == 0) {
          // Es el primero
          this.bagsRange[index + 1].from = 0;
          this.bagsRange.shift();
        } else if (index > 0 && index < this.bagsRange.length - 1) {
          // Esta en el medio
          this.bagsRange[index - 1].to = this.bagsRange[index + 1].from - 1;
          this.bagsRange.splice(index, 1);
        } else {
          // Es el ultimo
          this.bagsRange[index - 1].to = null;
          this.bagsRange.pop();
          return;
        }
      } else {
        // Hay un solo objeto
        this.message.info("Tiene que haber al menos una fila en la tabla");
        return;
      }
    },
    addField(index) {
      let thisRange = this.bagsRange[index];
      thisRange.to = thisRange.from + 99;
      this.bagsRange.push({
        from: thisRange.to + 1,
        to: null,
        price: thisRange.price,
      });
    },
    deleteSupplyFromTable(array, options, index) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === array[index].supply._id || options[i].value === array[index].supply) {
          options[i].disabled = false;
        }
      }

      array.splice(index, 1);
    },
    pushAdditive(e) {
      const additiveSupplies = this.supplies.filter(supply => supply.type === "additive");
      let selectedSupply = additiveSupplies?.find(supply => supply?._id == e);
      for (let i = 0; i < this.seedAdditives.length; i++) {
        if (this.seedAdditives[i].supply === selectedSupply?._id) {
          this.message.error("Producto ya añadido");
          return;
        }
      }
      (this.seedObj = {
        supply: e,
        name: selectedSupply?.name,
        dose: {
          recommended: null,
          min: null,
          max: null,
        },
        format: selectedSupply?.format.toUpperCase(),
      }),
        this.seedAdditives.push(this.seedObj);

      for (let i = 0; i < this.additiveOptions.length; i++) {
        if (this.additiveOptions[i]?.value === e) {
          this.additiveOptions[i].disabled = true;
        }
      }
    },
    pushFertilizer(e) {
      const fertilizerSupplies = this.supplies.filter(supply => supply.type === "fertilizer");
      let selectedSupply = fertilizerSupplies?.find(supply => supply?._id == e);
      for (let i = 0; i < this.seedFertilizer.length; i++) {
        if (this.seedFertilizer[i].supply === selectedSupply?._id) {
          this.message.error("Producto ya añadido");
          return;
        }
      }
      (this.seedObj = {
        supply: e,
        name: selectedSupply?.name,
        dose: {
          recommended: null,
          min: null,
          max: null,
        },
        format: selectedSupply.format.toUpperCase(),
      }),
        this.seedFertilizer.push(this.seedObj);

      for (let i = 0; i < this.fertilizerOptions.length; i++) {
        if (this.fertilizerOptions[i]?.value === e) {
          this.fertilizerOptions[i].disabled = true;
        }
      }
    },
    pushFertilizerAndPhytosanitary(e) {
      const fertilizerAndPhytosanitarySupplies = this.supplies.filter(supply => supply.type === "fertilizerAndPhytosanitary");
      let selectedSupply = fertilizerAndPhytosanitarySupplies?.find(supply => supply?._id == e);
      for (let i = 0; i < this.seedFertilizerAndPhytosanitary.length; i++) {
        if (this.seedFertilizerAndPhytosanitary[i].supply === selectedSupply?._id) {
          this.message.error("Producto ya añadido");
          return;
        }
      }
      (this.seedObj = {
        supply: e,
        name: selectedSupply?.name,
        dose: {
          recommended: null,
          min: null,
          max: null,
        },
        format: selectedSupply.format.toUpperCase(),
      }),
        this.seedFertilizerAndPhytosanitary.push(this.seedObj);

      for (let i = 0; i < this.fertilizerAndPhytosanitaryOptions.length; i++) {
        if (this.fertilizerAndPhytosanitaryOptions[i]?.value === e) {
          this.fertilizerAndPhytosanitaryOptions[i].disabled = true;
        }
      }
    },
    pushPhytosanitary(e) {
      const phytosanitarySupplies = this.supplies.filter(supply => supply.type === "phytosanitary");
      let selectedSupply = phytosanitarySupplies?.find(supply => supply?._id == e);
      for (let i = 0; i < this.seedPhytosanitary.length; i++) {
        if (this.seedPhytosanitary[i].supply === selectedSupply?._id) {
          this.message.error("Producto ya añadido");
          return;
        }
      }
      (this.seedObj = {
        supply: e,
        name: selectedSupply?.name,
        dose: {
          recommended: null,
          min: null,
          max: null,
        },
        format: selectedSupply.format.toUpperCase(),
      }),
        this.seedPhytosanitary.push(this.seedObj);

      for (let i = 0; i < this.phytosanitaryOptions.length; i++) {
        if (this.phytosanitaryOptions[i]?.value === e) {
          this.phytosanitaryOptions[i].disabled = true;
        }
      }
    },
    assignOptions(inputArray) {
      let myArray = [];
      for (let value of inputArray) {
        myArray.push({
          label: `${value.name}. (${value.format.toUpperCase()})`,
          value: value._id,
          name: value.name,
          disabled: false,
        });
      }
      return myArray;
    },
    async editSeed() {
      this.validateForm();
      try {
        if (this.isFormValid == true) {
          this.deleteAditionalValues();
          const suppliesData = this.seedAdditives.concat(this.seedFertilizer, this.seedFertilizerAndPhytosanitary, this.seedPhytosanitary);

          if (this.bagFormat == "kg") {
            this.amountPerBag.seeds = null;
          }
          if (this.bagFormat == "seeds") {
            this.amountPerBag.kg = null;
          }

          let seasonData = {
            winter: false,
            summer: false,
          };

          for (let i = 0; i < this.model.season.length; i++) {
            if (this.model.season[i] === "summer") {
              seasonData.summer = true;
            }

            if (this.model.season[i] === "winter") {
              seasonData.winter = true;
            }
          }

          let data = {
            name: this.model.name,
            type: this.type,
            provider: this.model.provider,
            product: this.model.product,
            gasoil: {
              recommended: this.model.recommendedGasoil,
              min: this.gasoil.min,
              max: this.gasoil.max,
            },
            pricePerBag: this.bagsRange,
            supplies: suppliesData,
            performancePerHectare: this.performancePerHectare,
            productivityBoost: this.productivityBoost,
            season: seasonData,
            bagsPerHectare: {
              recommended: this.model.recommendedBagsPerHectare,
              min: this.bagsPerHectare.min,
              max: this.bagsPerHectare.max,
            },
            format: this.model.bagFormat,
            amountPerBag: this.amountPerBag,
            isAvailable: this.isAvailable,
          };

          await this.updateSeed(this.$route.params.id, data);
          this.message.success("Semilla editada correctamente");
          this.loadingBar.finish();
          seasonData = {
            winter: false,
            summer: false,
          };
          this.$router.push("/app/supplies/seed/list");
        }
        this.isFormValid = true;
      } catch (err) {
        this.disableButton = false;
        this.loadingBar.error();
        console.error(err);
        this.message.error(e.response.data.message);
      }
    },
    validateForm() {
      this.$refs.formRef.validate();
      if (!this.model.name) {
        this.message.error("Por favor ingrese un nombre");
        this.isFormValid = false;
      }
      if (!this.model.provider) {
        this.message.error("Por favor seleccione un proveedor");
        this.isFormValid = false;
      }
      for (let i = 0; i < this.seedAdditives.length; i++) {
        if (!this.seedAdditives[i].dose.recommended) {
          this.message.error(`Por favor ingresar la cantidad recomendada para "${this.seedAdditives[i].name}"`);
          this.additiveStatus = "error";
          this.isFormValid = false;
        } else {
          this.additiveStatus = "success";
        }
        if (!this.seedAdditives[i].dose.min) {
          this.message.error(`Por favor ingresar la cantidad mínima para "${this.seedAdditives[i].name}"`);
          this.additiveStatus = "error";
          this.isFormValid = false;
        } else {
          this.additiveStatus = "success";
        }
        if (!this.seedAdditives[i].dose.max) {
          this.message.error(`Por favor ingresar la cantidad máxima para "${this.seedAdditives[i].name}"`);
          this.additiveStatus = "error";
          this.isFormValid = false;
        } else {
          this.additiveStatus = "success";
        }
        if (this.seedAdditives[i].dose.min && this.seedAdditives[i].dose.recommended < this.seedAdditives[i].dose.min) {
          this.message.error(`La cantidad recomendada de "${this.seedAdditives[i].name}" debe ser mayor al valor minimo de dosis`);
          this.additiveStatus = "error";
          this.isFormValid = false;
        } else {
          this.additiveStatus = "success";
        }
        if (this.seedAdditives[i].dose.max && this.seedAdditives[i].dose.recommended > this.seedAdditives[i].dose.max) {
          this.message.error(`La cantidad recomendada de "${this.seedAdditives[i].name}" debe ser menor al valor maximo de dosis`);
          this.additiveStatus = "error";
          this.isFormValid = false;
        } else {
          this.additiveStatus = "success";
        }
      }
      for (let i = 0; i < this.seedFertilizer.length; i++) {
        if (!this.seedFertilizer[i].dose.recommended) {
          this.message.error(`Por favor ingresar la cantidad recomendada para "${this.seedFertilizer[i].name}"`);
          this.fertilizerStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerStatus = "success";
        }
        if (!this.seedFertilizer[i].dose.min) {
          this.message.error(`Por favor ingresar la cantidad mínima para "${this.seedFertilizer[i].name}"`);
          this.fertilizerStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerStatus = "success";
        }
        if (!this.seedFertilizer[i].dose.max) {
          this.message.error(`Por favor ingresar la cantidad máxima para "${this.seedFertilizer[i].name}"`);
          this.fertilizerStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerStatus = "success";
        }
        if (this.seedFertilizer[i].dose.min && this.seedFertilizer[i].dose.recommended < this.seedFertilizer[i].dose.min) {
          this.message.error(`La cantidad recomendada de "${this.seedFertilizer[i].name}" debe ser mayor al valor minimo de dosis`);
          this.fertilizerStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerStatus = "success";
        }
        if (this.seedFertilizer[i].dose.max && this.seedFertilizer[i].dose.recommended > this.seedFertilizer[i].dose.max) {
          this.message.error(`La cantidad recomendada de "${this.seedFertilizer[i].name}" debe ser menor al valor maximo de dosis`);
          this.fertilizerStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerStatus = "success";
        }
      }
      for (let i = 0; i < this.seedFertilizerAndPhytosanitary.length; i++) {
        if (!this.seedFertilizerAndPhytosanitary[i].dose.recommended) {
          this.message.error(`Por favor ingresar la cantidad recomendada para "${this.seedFertilizerAndPhytosanitary[i].name}"`);
          this.fertilizerAndPhytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerAndPhytosanitaryStatus = "success";
        }
        if (!this.seedFertilizerAndPhytosanitary[i].dose.min) {
          this.message.error(`Por favor ingresar la cantidad mínima para "${this.seedFertilizerAndPhytosanitary[i].name}"`);
          this.fertilizerAndPhytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerAndPhytosanitaryStatus = "success";
        }
        if (!this.seedFertilizerAndPhytosanitary[i].dose.max) {
          this.message.error(`Por favor ingresar la cantidad máxima para "${this.seedFertilizerAndPhytosanitary[i].name}"`);
          this.fertilizerAndPhytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerAndPhytosanitaryStatus = "success";
        }
        if (
          this.seedFertilizerAndPhytosanitary[i].dose.min &&
          this.seedFertilizerAndPhytosanitary[i].dose.recommended < this.seedFertilizerAndPhytosanitary[i].dose.min
        ) {
          this.message.error(`La cantidad recomendada de "${this.seedFertilizerAndPhytosanitary[i].name}" debe ser mayor al valor minimo de dosis`);
          this.fertilizerAndPhytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerAndPhytosanitaryStatus = "success";
        }
        if (
          this.seedFertilizerAndPhytosanitary[i].dose.max &&
          this.seedFertilizerAndPhytosanitary[i].dose.recommended > this.seedFertilizerAndPhytosanitary[i].dose.max
        ) {
          this.message.error(`La cantidad recomendada de "${this.seedFertilizerAndPhytosanitary[i].name}" debe ser menor al valor maximo de dosis`);
          this.fertilizerAndPhytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.fertilizerAndPhytosanitaryStatus = "success";
        }
        delete this.seedFertilizerAndPhytosanitary[i].name;
        delete this.seedFertilizerAndPhytosanitary[i].format;
      }
      for (let i = 0; i < this.seedPhytosanitary.length; i++) {
        if (!this.seedPhytosanitary[i].dose.recommended) {
          this.message.error(`Por favor ingresar la cantidad recomendada para "${this.seedPhytosanitary[i].name}"`);
          this.phytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.phytosanitaryStatus = "success";
        }
        if (!this.seedPhytosanitary[i].dose.min) {
          this.message.error(`Por favor ingresar la cantidad mínima para "${this.seedPhytosanitary[i].name}"`);
          this.phytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.phytosanitaryStatus = "success";
        }
        if (!this.seedPhytosanitary[i].dose.max) {
          this.message.error(`Por favor ingresar la cantidad máxima para "${this.seedPhytosanitary[i].name}"`);
          this.phytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.phytosanitaryStatus = "success";
        }
        if (this.seedPhytosanitary[i].dose.min && this.seedPhytosanitary[i].dose.recommended < this.seedPhytosanitary[i].dose.min) {
          this.message.error(`La cantidad recomendada de "${this.seedPhytosanitary[i].name}" debe ser mayor al valor minimo de dosis`);
          this.phytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.phytosanitaryStatus = "success";
        }
        if (this.seedPhytosanitary[i].dose.max && this.seedPhytosanitary[i].dose.recommended > this.seedPhytosanitary[i].dose.max) {
          this.message.error(`La cantidad recomendada de "${this.seedPhytosanitary[i].name}" debe ser menor al valor maximo de dosis`);
          this.phytosanitaryStatus = "error";
          this.isFormValid = false;
        } else {
          this.phytosanitaryStatus = "success";
        }
      }

      if (this.model.recommendedGasoil == null) {
        this.message.error(`Por favor ingresar la cantidad recomendada de gasoil`);
        this.isFormValid = false;
      }
      if (this.gasoil.min && this.model.recommendedGasoil < this.gasoil.min) {
        this.message.error(`La cantidad recomendada de gasoil debe ser mayor al valor minimo de litros`);
        this.isFormValid = false;
      }
      if (this.gasoil.max && this.model.recommendedGasoil > this.gasoil.max) {
        this.message.error(`La cantidad recomendada de gasoil debe ser menor al valor maximo de litros`);
        this.isFormValid = false;
      }
      if (this.performancePerHectare.min && this.performancePerHectare.estimate < this.performancePerHectare.min) {
        this.message.error(`La cantidad estimada de performance por hectarea debe ser mayor al valor minimo`);
        this.performancePerHectareStatus = "error";
        this.isFormValid = false;
      } else {
        this.performancePerHectareStatus = "success";
      }
      if (this.performancePerHectare.max && this.performancePerHectare.estimate > this.performancePerHectare.max) {
        this.message.error(`La cantidad estimada de performance por hectarea debe ser menor al valor maximo`);
        this.performancePerHectareStatus = "error";
        this.isFormValid = false;
      } else {
        this.performancePerHectareStatus = "success";
      }
      if (this.productivityBoost.min > this.productivityBoost.max) {
        this.message.error(`La cantidad minima del boost de productividad debe ser menor que el valor maximo`);
        this.productivityBoostStatus = "error";
        this.isFormValid = false;
      } else {
        this.productivityBoostStatus = "success";
      }
      if (!this.amountPerBag.kg && !this.amountPerBag.seeds) {
        this.message.error(`Por favor ingrese una cantidad por bolsa`);
        this.amountPerBagStatus = "border: 2.5px solid red";
        this.isFormValid = false;
      } else {
        this.amountPerBagStatus = "border: 1px solid black";
      }
      if (this.model.recommendedBagsPerHectare == null) {
        this.message.error(`Por favor ingresar la cantidad recomendada por hectarea`);
        this.isFormValid = false;
      }
      if (this.bagsPerHectare.min && this.model.recommendedBagsPerHectare < this.bagsPerHectare.min) {
        this.message.error(`La cantidad recomendada por hectarea debe ser mayor al valor minimo de litros (${this.bagsPerHectare.min})`);
        this.bagsPerHectareStatus = "error";
        this.isFormValid = false;
      } else {
        this.bagsPerHectareStatus = "success";
      }
      if (this.bagsPerHectare.max && this.model.recommendedBagsPerHectare > this.bagsPerHectare.max) {
        this.message.error(`La cantidad recomendada por hectarea debe ser menor al valor maximo de litros (${this.bagsPerHectare.max})`);
        this.bagsPerHectareStatus = "error";
        this.isFormValid = false;
      } else {
        this.bagsPerHectareStatus = "success";
      }
    },
    deleteAditionalValues() {
      for (let i = 0; i < this.seedAdditives.length; i++) {
        delete this.seedAdditives[i].name;
        delete this.seedAdditives[i].format;
      }
      for (let i = 0; i < this.seedFertilizer.length; i++) {
        delete this.seedFertilizer[i].name;
        delete this.seedFertilizer[i].format;
      }
      for (let i = 0; i < this.seedFertilizerAndPhytosanitary.length; i++) {
        delete this.seedFertilizerAndPhytosanitary[i].name;
        delete this.seedFertilizerAndPhytosanitary[i].format;
      }
      for (let i = 0; i < this.seedPhytosanitary.length; i++) {
        delete this.seedPhytosanitary[i].name;
        delete this.seedPhytosanitary[i].format;
      }
    },
  },
};
</script>

<style scoped>
.gasoil-and-performance-width {
  width: 35rem;
}
</style>
